import { gql } from '@apollo/client';

export default gql`
  mutation overrideExchangeFees(
    $bookingReference: String!
    $currency: Currency!
    $reason: String
    $fareDiff: Boolean
    $offlineFee: Boolean
    $exchangeFee: Boolean
  ) {
    overrideExchangeFees(
      bookingReference: $bookingReference
      reason: $reason
      currency: $currency
      fareDiff: $fareDiff
      offlineFee: $offlineFee
      exchangeFee: $exchangeFee
    ) {
      reference
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      totalPendingCancellationFarePrice: totalPendingCancellationFarePriceWithCurrency(currency: $currency)
      totalPendingCreationFarePrice
      totalExchangeFee: totalExchangeFeeWithCurrency(currency: $currency)
      provisionalOfflineFees: fees(provisional: true) {
        code
        price
        cancelled
      }
      fees {
        code
        name
        price
        cancelled
        provisional
      }
      pendingCancellationLegs {
        ...pendingLeg
      }
      pendingCreationLegs {
        ...pendingLeg
      }
    }
  }

  fragment pendingLeg on Leg {
    direction
    fees {
      price
      cancelled
      provisional
    }
    bookingItems: products {
      price
      cancelled
      provisional
    }
  }
`;
